var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleIconRightInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.75L9 20.25L16.875 12.375L9 4.5L7.5 6L12.7529 11.2529H0.75V13.5029H12.7471L7.5 18.75Z",
    fill: "#898E97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 12.375L14.25 18.75L15.75 20.25L23.625 12.375L15.75 4.5L14.25 6L20.625 12.375Z",
    fill: "#898E97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleIconRightInactive);
export default __webpack_public_path__ + "static/media/double-icon-right-inactive.3a702ebc12a500fceeab3bd1c5bca243.svg";
export { ForwardRef as ReactComponent };